import React from "react";
import PropTypes from "prop-types";
import { pageOptions } from "utils/constants";
import { Select, Typography, Pagination } from "components";

const TableFooter = ({
  pageSize,
  handleChange,
  availableDataLength,
  totalDataLength,
  handlePageClick,
  pageOptionsName,
  forcePage,
}) => {
  return (
    <div className="mt-4 d-flex justify-content-space-between align-items-center table-footer-container ">
      <div className="d-flex align-items-center w-100">
        <Typography variant="caption2">Show</Typography>
        <Select
          size="sm"
          name={pageOptionsName || "size"}
          options={pageOptions}
          value={pageSize}
          onChange={handleChange}
          required={false}
          className="mx-3"
        />
        <Typography variant="caption2">per page</Typography>
      </div>
      <Typography className="w-100 sm-margin" variant="caption1" state="grey">
        Showing {availableDataLength} out of {totalDataLength} Results
      </Typography>

      <Pagination
        dataSize={totalDataLength}
        perPage={pageSize}
        forcePage={forcePage}
        handlePageClick={(pageNo) => handlePageClick(pageNo)}
      />
    </div>
  );
};

TableFooter.propTypes = {
  pageSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleChange: PropTypes.func,
  availableDataLength: PropTypes.number,
  totalDataLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handlePageClick: PropTypes.func,
  pageOptionsName: PropTypes.string,
  forcePage: PropTypes.number,
};

export default TableFooter;
